import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import './global.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { loadSysConfig } from './utils/sysConfig'

const app = createApp(App)
app.use(router)
app.use(ElementPlus, { locale: zhCn })

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.mount('#app')

// 启动时加载一次系统基础配置（名称/可视化名称/LOGO 等）
loadSysConfig()

const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        if (Array.isArray(entries) && document.contains(entries[0]?.target)) {
          callback(entries, observer)
        }
      })
    })
  }
}